export default [
  {
    path: '/filial/',
    name: 'filial',
    title: 'filial',
    component: () => import('../views/FilialView.vue'),
    redirect: { name: 'filial-cadastrar' },
    children: [
      {
        path: 'welcome',
        name: 'filial-listar',
        component: () => import('../views/FilialWelcomeView.vue'),
        meta: {
          title: 'Filial',
        },
      },
      {
        path: ':codigo',
        name: 'filial-editar',
        meta: {
          title: 'Filial editar',
        },
        component: () => import('../views/FilialFormView.vue'),
      },
      {
        path: 'selecionar',
        name: 'filial-selecionar',
        component: () => import('../views/FilialSelecionarView.vue'),
        meta: {
          layout: 'EmptyLayout',
        },
      },
    ],
  },
];
